import { useState, useEffect, useRef } from "react";
import image1 from '../../public/images/Birthday-Leads.png';
import image2 from '../../public/images/PreCall-Leads.png';
import image3 from '../../public/images/Sponsor-Leads.png';
import image4 from '../../public/images/Thank You-Leads.png';



const emailTemplate = () => `
<p>Dear <b>${"Donor"}</b>,</p>




<p>Greetings from Plan India!</p>

<p>
  I hope this mail finds you well and hope you are having a good day.<br>
  It was very nice talking to you. Your passion towards giving back to the society fills me with hope of a better and a brighter future. Your support is not just financial, but a lifeline to those kids whom you so generously support.<br>
  As per our discussion, I understand that you wish to have a more holistic experience through your contributions and see how your support is changing lives. With this in mind, I would like to introduce you to our one-of-a-kind <b>‘Sponsor a Child’ Programme</b>.
</p>

<p><b>SPONSOR CHILD</b></p>

<p>
  With issues like child marriage, malnutrition, and genderbased violence casting a shadow over the bright future of kids, Plan India started the <b>Sponsor a Child programme</b> to provide essential support to vulnerable children from the age of 0-24. Sponsor a Child is a holistic programme that ensures a child has access to basic necessities he/she deserves including quality education, health and hygiene, nutrition and early child development, vocational training and capacity building, job placement and income resources, child safety and protection and emergency protection support.
</p>

<h3 style="color: #005bbb;">WHY SPONSOR A CHILD WITH PLAN INDIA?</h3>

<p>
  Plan India’s ‘Sponsor a Child’ programme has made an impact on over <b>750,000 children</b> and their communities till date. Our widespread presence and connection with local communities helps us in understanding the ground realities. It has taught us that helping families and communities become self-sufficient is the best way to secure children’s futures.
</p>

<p>
  This programme is currently being implemented in <b>eight states in India</b> i.e. Bihar, Delhi, Jharkhand, Odisha, Rajasthan, Telangana, Uttarakhand and Uttar Pradesh.
</p>

<img src="PATH_TO_MAP_IMAGE" alt="Plan India States Map" style="width:80%;max-width:300px;display:block;margin:24px auto 18px auto;" />

<h3 style="color: #005bbb;">WHY SPONSOR A CHILD?</h3>

<p>
  Bringing a child into our world is one of the most joyous moments. But there is one factor that will decide how the world treats the child – gender. From birth to growing into a working adult, girls see a world that is starkly different from the ones boys see.
</p>
<ul>
  <li><b>3 out of 5 women</b> have not completed their school/education</li>
  <li><b>1 in 4 women</b> are married before they turn 18 years of age</li>
  <li><b>4 in 100 children</b> die before celebrating their first birthday due to malnutrition and lack of access to quality health services.</li>
</ul>

<h3>SEE HOW YOUR SUPPORT MAKES A DIFFERENCE</h3>

<p>
  When you sponsor a child with Plan India, you give these kids hope that a better future exists where that can dream. You bring these children out of the misery and fear of being pushed into child marriage, child labour or human trafficking.
</p>
<p>
  We believe in fostering strong bonds between the sponsors and their sponsored children.
  <ul>
    <li><b>Build a personal connection:</b> The sponsor can meet their sponsored children. They can also exchange messages, letters, pictures and drawings and through this form a strong and lasting relationship</li>
    <li><b>Nurture Potential:</b> Plan India provides the Sponsor with an annual update on the work and change that Plan India has delivered within the Sponsored Child’s wider community and region.</li>
    <li>See Manisha Semwal, a sponsored child’s story <a href="https://www.youtube.com/watch?v=TcwFip0u5v0">here.</a></li>
  </ul>
</p>

<h3>WHAT WE AIM TO ACCOMPLISH IN FY 2025</h3>

<p>
  Plan India’s ‘Sponsor a Child’ programme was started with a vision to ensure a child gets all the support he/she needs to become independent and self-sufficient. Keeping this in mind, Plan India provides support in key areas that impact a child since birth including education, health, nutrition and protection from gender-based violence, thus ensuring that the basic human rights are not denied to any child. <b>We aim to sponsor 3000 girls in FY 2025 by ensuring they are able to learn, lead, decide and thrive.</b>
</p>
<p>
  Thousands of girls can dream of a future without gender inequality, without pay disparity, without gender-based abuse, a future where menstrual hygiene is not a taboo, a future where the smiles do not fade away upon the birth of a girl child, a future where education of girls is top priority – <b>just with your support.</b>
</p>
<p>
  I hope you will once again start your journey of making a difference with Plan India and gift young girls and boys another chance at life. Kindly let me know if you wish for any more information.
</p>
<p>
  Please feel free to go through our website:<br>
  <a href="https://www.planindia.org/get-involved/make-a-donation/sponsor-a-child-2/">https://www.planindia.org/get-involved/make-a-donation/sponsor-a-child-2/</a>
</p>

<p>Looking forward to your revert.</p>
<br>
<p>Regards<br>Plan India</p>


`;



const TEMPLATE_BODIES = {
    "Bluesheet Template": `
        <img src="/images/image1.png" style="width:100%; max-width:300px;" />
    `,

    "General Donation Thank You Mail on Leads ": `
        <p>Thank you for your donation!</p>
        <img src="/images/thankyou.png" style="width:100%; max-width:300px;" />
    `,

    "Sponsorship Acquisition Template": `
        <p>Happy Birthday 🎉</p>
        <img src="/images/birthday.png" style="width:100%; max-width:300px;" />
    `,
    "Introductory Pre Call": `
        <img src="/images/thankyou.png" style="width:100%; max-width:300px;" />
    `,
};





// console.log({lead})



export default function SendMailModal({ idToFetch, onClose, firstName, lastName, onEmailSent, lead }) {

    const formatFullName = (first, last) => {
        const parts = [];
        if (first) parts.push(first);
        if (last) parts.push(last);
        return parts.join(" ");
    };
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    useEffect(() => {
        if (!selectedTemplate) return; // 👈 Prevents error when it's still null
        setSubject(replacePlaceholders(selectedTemplate.subject || "", firstName));
        setEmailBody(replacePlaceholders(selectedTemplate.body || "", firstName));
    }, [selectedTemplate, firstName]);

    // const TEMPLATES = [
    //     {
    //         name: "Sponsorship Mail - New Donors",
    //         subject: "Sponsorship Mail - New Donors",
    //         id: "760958000004727012",
    //         body: emailTemplate()
    //     },
    //     {
    //         name: "General Donation Thank You Mail on Leads",
    //         subject: `Thank You ${formatFullName(firstName, lastName)}`,
    //         id: "760958000001452060",
    //         body: `Dear,\n\nThank you for your support...`
    //     },
    //     {
    //         name: "Sponsorship Acquisition Template",
    //         subject: "Sponsorship Acquisition Template",
    //         id: "760958000004792624",
    //         body: `Sponsorship Template`
    //     },
    //     {
    //         name: "Introductory Pre Call",
    //         subject: "Introductory Pre Call",
    //         id: "760958000004792548",
    //         body: `Introductory Pre Call - Leads`
    //     },
    //     {
    //         name: "Birthday Template",
    //         subject: `Happy Birthday - ${formatFullName(firstName, lastName)}`,
    //         id: "760958000000928637",
    //         body: `Happy Birthday, [firstName]!`
    //     }
    // ];

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await fetch("/server/dealer_backend/getEmailTemplates", {
                    method: "GET",

                });

                const data = await response.json();

                if (data.status === "success") {
                    const filteredTemplates = data?.data.filter(tpl => tpl?.module?.api_name === "Leads");
                    setTemplates(filteredTemplates); // API already returns active templates
                    // 👇 Set the first template as default selection
                    setSelectedTemplate(data.data[0]);
                } else {
                    console.error("Failed to load templates:", data.error);
                }
            } catch (error) {
                console.error("Error fetching templates:", error);
            }
        };

        fetchTemplates();
    }, []);

    function replacePlaceholders(text, firstName) {
        return text.replace(/\[firstName\]/g, firstName || '');
    }



    const editorRef = useRef(null);

    // 🧠 Update subject/body whenever selected template or firstName changes
    // useEffect(() => {
    //     if (selectedTemplate) {
    //         setSubject(replacePlaceholders(selectedTemplate.subject || "", firstName));
    //         setEmailBody(replacePlaceholders(selectedTemplate.body || "", firstName));
    //     }
    // }, [selectedTemplate, firstName]);



    const [emailBody, setEmailBody] = useState("");
    const [initialized, setInitialized] = useState(false);
    const [recipient, setRecipient] = useState(lead?.Email || "");

    const [replyTo, setReplyTo] = useState("donor.service@planindia.org");
    const [subject, setSubject] = useState("");
    const [cc, setCC] = useState("");

    const [isSending, setIsSending] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    // Update editor content when template changes
    // useEffect(() => {
    //     if (!selectedTemplate) return; // ✅ Guard clause prevents reading null
    //     setSubject(selectedTemplate.name || "");
    //     setEmailBody(selectedTemplate.body || "");
    // }, [selectedTemplate]);






    // Initialize editor content only when selectedTemplate changes (once)
    // useEffect(() => {
    //     if (!initialized && selectedTemplate?.body) {   // ✅ only run if body exists
    //         const html = selectedTemplate.body.replace(/\n/g, "<br>");
    //         setEmailBody(html);
    //         setInitialized(true);
    //     }
    // }, [selectedTemplate, initialized]);

    useEffect(() => {
        if (!selectedTemplate) return;

        setSubject(
            replacePlaceholders(selectedTemplate.subject || "", firstName)
        );

    }, [selectedTemplate, firstName]);

    const imageTemplates = [
        "introductory pre call",
        "general donation thank you mail on leads",
        "sponsorship acquisition template",
        "birthday template-"
    ];


    const isImageTemplate = imageTemplates.includes(
        selectedTemplate?.name?.toLowerCase()
    );


    const handleTemplateChange = (e) => {
        const selectedId = e.target.value;
        const template = templates.find((t) => t.id === selectedId);

        setSelectedTemplate(template);
    };

// console.log("Template name:", selectedTemplate?.name?.toLowerCase());




    const onInputHandler = (e) => {
        setEmailBody(e.currentTarget.innerHTML);
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
        return re.test(String(email).toLowerCase());
    };


    const sendEmail = async () => {
        if (!recipient) {
            alert("Please enter recipient's email");
            return;
        }

        if (!validateEmail(recipient)) {
            alert("❌ Please enter a valid recipient email address");
            return;
        }

        if (replyTo && !validateEmail(replyTo)) {
            alert("❌ Please enter a valid 'Reply-To' email address");
            return;
        }

        if (cc && !validateEmail(cc)) {
            alert("❌ Please enter a valid CC email address");
            return;
        }

        const emailData = {
            from: {
                user_name: "Plan International_India Chapter",
                email: "plan.donate@planindia.in",
            },
            to: [
                {
                    user_name: "Recipient Name",
                    email: recipient,
                },
            ],
            reply_to: {
                user_name: "user5",
                email: replyTo,
            },
            subject: subject,
            mail_format: "html",
            org_email: true,
            template: {
                id: selectedTemplate.id,
            }
        };

        if (cc?.trim()) {
            emailData.cc = [
                {
                    // user_name: "user3",
                    email: cc.trim(),
                }
            ];
        }

        const payload = {
            id: idToFetch,
            data: [emailData],
        };

        setIsSending(true);

        try {
            const module = "Leads";
            const response = await fetch(`/server/dealer_backend/send-email?module=${module}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            if (response.ok) {
                setShowSuccessModal(true);
                if (typeof onEmailSent === "function") {
                    onEmailSent();
                }
            } else {
                alert("Failed to send email: " + result.error);
            }
        } catch (error) {
            alert("Error sending email: " + error.message);
        } finally {
            setIsSending(false);
        }
    };


    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            <div className="bg-white rounded-[20px] shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-[#14446D22] animate-fade-in">

                {/* Header */}
                <div className="flex justify-between items-center border-b px-8 py-5" style={{ backgroundColor: '#14446D' }}>
                    <span className="font-semibold text-xl flex items-center gap-2 text-white">
                        📧
                    </span>
                    <div className="flex gap-3 items-center">
                        <select
                            id="templateSelect"
                            className="rounded px-3 py-1.5 text-sm bg-white text-[#14446D] focus:ring-2 focus:ring-[#14446D66] transition"
                            value={selectedTemplate?.id || ""}
                            onChange={handleTemplateChange}
                        >
                            <option value="">Select a template</option>
                            {templates.map((tpl) => (
                                <option key={tpl.id} value={tpl.id}>
                                    {tpl.name}
                                </option>
                            ))}
                        </select>
                        <button
                            className="text-2xl text-white hover:bg-[#14446D22] transition p-1 rounded"
                            title="Close"
                            aria-label="Close"
                            onClick={onClose}
                        >
                            &times;
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="px-8 pt-6 pb-8 flex flex-col gap-5 overflow-auto text-[#14446D]">

                    {/* Recipient, Reply-To */}
                    <div className="flex gap-5 items-start">
                        <div className="flex flex-col flex-1">
                            <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>To</label>
                            <input
                                type="email"
                                className="w-full rounded-lg border border-[#14446D33] focus:ring-2 focus:ring-[#14446D66] px-4 py-2 text-sm transition"
                                placeholder="Recipient's email"
                                value={recipient}
                                onChange={e => setRecipient(e.target.value)}
                                required
                                autoFocus
                            />
                        </div>
                        <div className="flex flex-col flex-1">
                            <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>Reply-To</label>
                            <input
                                type="email"
                                className="w-full rounded-lg border border-[#14446D33] focus:ring-2 focus:ring-[#14446D66] px-4 py-2 text-sm transition"
                                placeholder="Reply to email"
                                value={replyTo}
                                onChange={e => setReplyTo(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* CC Field */}
                    <div>
                        <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>CC</label>
                        <input
                            type="email"
                            className="w-full rounded-lg border border-[#14446D33] focus:ring-2 focus:ring-[#14446D66] px-4 py-2 text-sm transition"
                            placeholder="CC email (optional)"
                            value={cc}
                            onChange={e => setCC(e.target.value)}
                        />
                    </div>

                    {/* Subject */}
                    <div className="flex flex-col">
                        <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>Subject</label>
                        <input
                            className="w-full rounded-lg border border-[#14446D33] focus:ring-2 focus:ring-[#14446D66] px-4 py-2 text-sm transition"
                            value={subject}
                            onChange={e => setSubject(e.target.value)}
                        />
                    </div>

                    {/* Message Body */}
                    {/* <div className="flex flex-col flex-1 min-h-[250px]">
                        <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>Message</label>
                        <div
                            ref={editorRef}
                            contentEditable
                            className="border rounded-lg p-4 min-h-[200px] text-sm bg-[#F6FAFD] focus:outline-none focus:ring-2 focus:ring-[#14446D33] transition"
                            onInput={onInputHandler}
                            suppressContentEditableWarning={true}
                            style={{ borderColor: "#14446D33" }}
                        />
                    </div> */}
                    {isImageTemplate && (
                        <div className="flex flex-col flex-1 min-h-[250px]">
                            <label className="font-semibold text-xs mb-2" style={{ color: '#14446D' }}>
                                Email Preview
                            </label>

                            <div
                                className="border rounded-lg p-4 min-h-[200px] bg-white overflow-auto"
                                style={{ borderColor: "#14446D33" }}
                            >

                                {selectedTemplate?.name?.toLowerCase().includes("birthday template") && (
                                    <img src={image1} style={{ width: "100%", maxWidth: 300 }} />
                                )}



                                {selectedTemplate?.name?.toLowerCase() === "introductory pre call" && (
                                    <img src={image2} style={{ width: "100%", maxWidth: 300 }} />
                                )}

                                {selectedTemplate?.name?.toLowerCase() === "general donation thank you mail on leads" && (
                                    <img src={image4} style={{ width: "100%", maxWidth: 300 }} />
                                )}

                                {selectedTemplate?.name?.toLowerCase() === "sponsorship acquisition template" && (
                                    <img src={image3} style={{ width: "100%", maxWidth: 300 }} />
                                )}


                            </div>
                        </div>
                    )}


                </div>

                {/* Footer */}
                <div className="border-t px-8 py-5 flex justify-end gap-3 bg-[#F6FAFD] rounded-b-[20px]">
                    <button
                        onClick={onClose}
                        className="px-5 py-2 font-semibold text-[#14446D] bg-white hover:bg-[#14446D11] rounded-lg transition focus:ring-2 focus:ring-[#14446D33]"
                        disabled={isSending}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={sendEmail}
                        className="px-5 py-2 font-semibold bg-[#14446D] text-white rounded-lg shadow hover:brightness-110 transition focus:ring-2 focus:ring-[#14446D44] disabled:opacity-60"
                        disabled={!recipient || isSending}
                    >
                        {isSending ? "Sending..." : (
                            <span className="inline-flex items-center gap-2">
                                <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={2}>
                                    <path d="M2 16l16-7-16-7v6l12 1-12 1z" />
                                </svg>
                                Send
                            </span>
                        )}
                    </button>
                </div>
            </div>
            {/* ✅ Success Modal */}
            {showSuccessModal && (
                <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
                    <div className="bg-white p-8 rounded-[20px] shadow-xl text-center max-w-sm w-full">
                        <h2 className="text-2xl font-bold text-green-600">✅ Email Sent!</h2>
                        <p className="mt-3 text-gray-600">Your email has been sent successfully.</p>
                        <button
                            onClick={() => { setShowSuccessModal(false); onClose(); }}
                            className="mt-5 px-5 py-2 bg-[#14446D] text-white rounded-lg hover:brightness-110"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );


}
